module.exports = __webpack_public_path__ + "static/media/fruittool_output.4add8fa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FruitTool/fruittool_output.png
// module id = 2539
// module chunks = 0